enum GravityType {
  NORTH = 'no',
  SOUTH = 'so',
  EAST = 'ea',
  WEST = 'we',
  NORTHEAST = 'noea',
  NORTHWEST = 'nowe',
  SOUTHEAST = 'soea',
  SOUTHWEST = 'sowe',
  CENTER = 'ce',
  SMART = 'sm',
  FOCUS_POINT = 'fp',
}

export default GravityType;
